export const CART_ACTION_TYPES = {
  SET_IS_DROPDOWN_ON: "SET_IS_DROPDOWN_ON",
  SET_CART_ITEMS: "SET_CART_ITEMS",
  SET_CART_COUNT: "SET_CART_COUNT",
  SET_CART_TOTAL: "SET_CART_TOTAL",
};
